import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, message, Spin } from "antd";
import { useParams, useNavigate } from "react-router-dom"; 
import { getCandidatesApi, updateCandidateApi } from "../../../apiservice/ats";

const EditCandidate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await getCandidatesApi({ id });
      const data = res?.data;

      if (!data) {
        message.error("Candidate not found");
        return;
      }

      form.setFieldsValue(data);
      setLoading(false);
    } catch (err) {
      message.error("Failed to load candidate");
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onFinish = async (values) => {
    try {
      await updateCandidateApi({ ...values, id });
      message.success("Candidate updated successfully");
      navigate(`/ats/candidates/${id}`);
    } catch (err) {
      message.error("Update failed");
    }
  };

  if (loading) return <Spin size="large" />;

  return (
    <Card title="Edit Candidate">
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Email" name="email" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Job Title" name="job_title">
          <Input />
        </Form.Item>

        <Form.Item label="Status" name="status">
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Changes
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default EditCandidate;
